import Vue from 'vue';
import eventBus from '@/utils/event-bus';
import { getPoiId, getActiveSubApiTypes } from '@/utils/poi-utils';
import { getPoiConfig } from '@/utils/poi-data/poi-config'
import { getPoiParams } from '@/utils/poi-params';

export function selectPOI(state, payload) {
    if(state.selectedPOIs.includes(payload)) return false;
    state.selectedPOIs.push(payload);
}

export function deselectAllPOIs(state) {
    state.selectedPOIs = [];
}

export function deselectPOI(state, payload) {
    if(!state.selectedPOIs.includes(payload)) return false;
    let index = state.selectedPOIs.findIndex(poi => poi === payload);
    state.selectedPOIs.splice(index, 1);
}

export function setLoadingPOIType(state, {loading, type}) {
    if(loading) {
        if(state.loadingPOIs.includes(type)) return false;
        state.loadingPOIs.push(type);
    } else {
        if(!state.loadingPOIs.includes(type)) return false;
        let index = state.loadingPOIs.findIndex(poi => poi === type);
        state.loadingPOIs.splice(index, 1);
    }
}

export function setPoiLoading(state, payload) {
    state.poiLoading = payload
}

export function setPoiResults(state, payload) {
    state.poiResults = payload
}

export function setPoiResultsByType(state, payload) {
    Vue.set(state.poiResults, payload.type, payload.data)
}

export function appendPoiResultsByType(state, payload) {
    let currentItems = state.poiResults[payload.type];
    let newItems = payload.data.filter(newPoi => {
        return !currentItems.find(currentPoi => getPoiId(payload.type, currentPoi) === getPoiId(payload.type, newPoi));
    })
    let addedArrays = currentItems.concat(newItems);

    state.poiResults[payload.type] = addedArrays;
}

export function removePOIResultType(state, type) {
    Vue.delete(state.poiResults, type)
    eventBus.$emit('removePoisFromMap', {type})

    const poiConfig = getPoiConfig(type)
    const params = getPoiParams(type);
    let subApiTypes = getActiveSubApiTypes(poiConfig, params);
    if(subApiTypes) {
        subApiTypes.forEach(subApiType => {
            eventBus.$emit('removePoisFromMap', {type: subApiType})
        })
    }
}

export function setActivePoiId(state, payload) {
    if(state.activePoiId === payload) {
        payload = false;
    }
    state.activePoiId = payload
}

export function setTrafficPOIselected(state, payload) {
    state.trafficPOIselected = payload;
}

export function setIsNearbyStationsListOpen(state, payload) {
    state.isNearbyStationsListOpen = payload;
}

export function setMyOeamtcBase(state, payload) {
    state.myOeamtcBase = payload
}

export function setCustomActivePoiType(state, payload) {
    state.customActivePoiType = payload
}

export function setCustomActivePoiSubType(state, payload) {
    state.customActivePoiSubType = payload
}

export function setPOIPaginationDataByType(state, payload) {
    state.poiPaginationData[payload.type] = payload;
}

export function setPoiPaginationMore(state, payload) {
    state.poiPaginationData[payload.type].more = payload.more;
}

export function resetPoiPaginationsMore(state) {
    for(let type in state.poiPaginationData) {
        state.poiPaginationData[type].more = true;
    }
}

export function resetPoiPagination(state) {
    state.poiPaginationData = {};
}

export function setPoiSorting(state, payload) {
    state.poiSorting = payload;
}

export function updatePoiFavourites(state, payload) {
    // also update poiResults immediately in case they are active
    if(state.poiResults && state.poiResults.favourites) {
        const poiFavIndex = state.poiResults.favourites.findIndex(favourite => favourite.id === payload.id);
        state.poiResults.favourites.splice(poiFavIndex, 1, payload)
        eventBus.$emit('poiFavouritesUpdated', payload)
        eventBus.$emit('updateMapMarker', { id: payload.id, lat: payload.lat, lon: payload.lon })
    }
}

export function setPoiApiErrorsByType(state, payload) {
    Vue.set(state.poiApiErrors, payload.type, payload.data)
}

export function setPoiToRemoveFromMap(state, payload) {
    state.poiToRemoveFromMap = payload
}

export function setPreviousActivePoi(state, payload) {
    state.previousActivePoi = payload
}

export function setDynamicPoiElements(state, payload) {
    state.dynamicPoiElements[payload.type] = payload.data
}